import { CommonModule } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { NgChartsModule } from 'ng2-charts';
import { NgxMasonryModule } from 'ngx-masonry';

import { AppService } from '../app.service';
import { AccountComponent } from './components/account/account.component';
import { TableComponent } from './components/table/table.component';
import { AutocompleteComponent } from './components/autocomplete/autocomplete.component';
import { ImgPreviewModule } from './components/img-preview/img-preview.module';
import { LoaderComponent } from './components/loader/loader.component';
import { ManagementComponent } from './components/management/management.component';
import { MenuComponent } from './components/menu/menu.component';
import { MultiselectComponent } from './components/multiselect/multiselect.component';
import { PaginatorComponent } from './components/paginator/paginator.component';
import { SidebarCommentsComponent } from './components/sidebar-comments/sidebar-comments.component';
import { SidebarComponent } from './components/sidebar/sidebar.component';
import { SidenavComponent } from './components/sidenav/sidenav.component';
import { SnackbarComponent } from './components/snackbar/snackbar.component';
import { TopbarComponent } from './components/topbar/topbar.component';
import { ImgPreviewDirective } from './directives/img-preview.directive';
import { InViewportDirective } from './directives/in-viewport.directive';
import { LoadingDirective } from './directives/loading.directive';
import { LoaderService } from './services/loader.service';
import { SidenavService } from './services/sidenav.service';
import { StudiosHttpClientService } from './services/studios-http-client.service';
import { TopbarService } from './services/topbar.service';
import { UtilitiesService } from './services/utilities.service';
import { ModalComponent } from './components/modal/modal.component';
import { ChipContainerComponent } from './components/chip-container/chip-container.component';
import { MatIconModule } from '@angular/material/icon';
import { HasRoleDirective } from '../services/directives/has-role.directive';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    RouterModule,
    ImgPreviewModule,
    NgChartsModule,
    NgxMasonryModule,
    MatIconModule,
    HasRoleDirective
  ],
  declarations: [
    SidebarComponent,
    SidenavComponent,
    TopbarComponent,
    MenuComponent,
    LoadingDirective,
    InViewportDirective,
    ImgPreviewDirective,
    PaginatorComponent,
    AutocompleteComponent,
    SidebarCommentsComponent,
    SnackbarComponent,
    MultiselectComponent,
    LoaderComponent,
    AccountComponent,
    ManagementComponent,
    TableComponent,
    ModalComponent,
    ChipContainerComponent,
  ],
  exports: [
    ImgPreviewModule,
    SidebarComponent,
    SidenavComponent,
    TopbarComponent,
    MenuComponent,
    LoadingDirective,
    InViewportDirective,
    ImgPreviewDirective,
    PaginatorComponent,
    AutocompleteComponent,
    SidebarCommentsComponent,
    SnackbarComponent,
    MultiselectComponent,
    LoaderComponent,
    AccountComponent,
    ManagementComponent,
    TableComponent,
    ModalComponent,
    ChipContainerComponent
  ],
  providers: [
    //AppService,
    HttpClient,
    TopbarService,
    SidenavService,
    UtilitiesService,
    LoaderService,
    StudiosHttpClientService
  ]
})
export class SharedModule { }
